import { MainProduct } from '../../../types'

export const getMainProductVariantById = (
  mainProduct: MainProduct,
  mainProductVariantId: string
) => {
  return mainProduct.variants.find((mainProductVariant) => Number(mainProductVariant.id) === Number(mainProductVariantId))
}

export const getPendantProductVariantById = (
  mainProduct: MainProduct,
  pendantProductVariantId: string
) => {
  return mainProduct.metafields.pendantProducts
    .flatMap((pendantProduct) => pendantProduct.variants)
    .find((pendantProductVariant) => Number(pendantProductVariant.id) === Number(pendantProductVariantId))
}